module.exports = __webpack_public_path__ + "static/media/graphic-design.6ca2095c.png";